import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SupporterDialogComponent } from '../supporter-dialog/supporter-dialog.component';

@Component({
    selector: 'supporter-widget',
    templateUrl: './supporter-widget.component.html',
    styleUrl: './supporter-widget.component.scss',
    standalone: false
})
export class SupporterWidgetComponent {
  @Input() isSupporter: boolean = false;
  @Input() isSubscribed: boolean = false;

  constructor(
    private readonly dialog: MatDialog
  ) {}

  openSupporterDialog(): void {
    if(!this.isSubscribed) return;

    this.dialog.open<SupporterDialogComponent>(SupporterDialogComponent,
      {
        autoFocus: false, // To prevent select state of close button in header
        data: {
          isSupporter: this.isSupporter
        }
      }
    )
  }
}
